import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Injector, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as L from 'leaflet';
import 'leaflet.vectorgrid';
import 'src/assets/leaflet-geojson-tilelayer/TileLayer.GeoJSON.js';
import 'src/assets/leaflet-image-transform/L.ImageTransform.js';
import 'src/assets/leaflet-spin/leaflet.spin.js';
import 'src/assets/leaflet-spin/leaflet.spin.min.js';
import 'src/assets/leaflet-velocity-src/js/L.CanvasLayer.js';
import 'src/assets/leaflet-velocity-src/js/L.Control.Velocity.js';
import 'src/assets/leaflet-velocity-src/js/L.VelocityLayer.js';
import 'src/assets/leaflet-velocity-src/js/windy.js';
import 'src/assets/map-control/L.control.HtmlLegend.js';
import 'src/assets/map-control/L.Control.ZoomBar.js';

import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { Chartconstant } from 'src/app/utils/chart.constant';
import { MapService } from 'src/app/utils/map.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined, isUndefined } from 'util';

import {
  FlowForecastUtilsService,
} from '../../widget-gis-components/flow-forecast/utils/service/flow-forecast-utils.service';
import { UtilsSharedModule } from '../utils/utils/utils.module';

@Component({
  selector: 'app-gis-map-widget-ff',
  templateUrl: './gis-map-widget-ff.component.html',
  styleUrls: ['./gis-map-widget-ff.component.scss']
})
export class GisMapWidgetFfComponent implements OnInit, AfterViewInit {

  @Input() otherOptions: any;
  @Input() mapId = 'map';

  map: L.Map;
  flag = true;
  geoJsonData: any;
  playButtonDisable = true;
  indexForLeftPanel: any;
  citiesData: any;
  chartData: any = [];
  chartOptions: any;
  context: CanvasRenderingContext2D;
  tsArrayForPlay: any = [];
  tsLabelsArrayForPlay: any = [];
  direction: any;
  state = 'stop';
  popUpData: any = {};
  postData: any;
  bottomBarData: any;
  bottomBarColumns: any = [];
  velocityLayer: any;
  wmsLayerGroup: any;
  allLayerList: any = [];
  overlayLayerList: any = [];
  geojsonLayerList: any = [];
  wmsLayerList: any = [];
  wmsUrl: any;
  wmsLayer: any;
  value: any = 3;
  imageUrl: any;
  adminSelected: any;
  forecastLength: any;
  shortLongRange: any;
  imageBounds: any = [];
  playpause: boolean;
  startIndex = 1;
  imageLayer: any;
  showThrobber: any;
  bottomBarMenuSelectedIndex: any;
  styleObjforBottomBar = {};
  vectorTileLayer = {};
  urlParams: any = {};
  labelStrings = [];
  marker = null;
  noData = false;
  blocks: any;
  Linechart: any;
  millisInSixHours = ProjConstants.MILLIS_IN_6HOURS;
  showBottomBar: any;
  districtClicked: object;
  particleMultiplier: any = 0.0006;
  showThrobberbottomBar = false;
  abbrvMapping = ProjConstants.COMPONENT_ABBREVIATION_MAPPING;
  heatMapoptions = {
    opacity: 0.8,
    pane: 'heatMap',
    minZoom: 6,
    maxZoom: 15
  };
  layers: any = {
    overlaylayers: {},
    baselayers: {}
  };
  borderBottomBarStyle = {};
  // timestamp:;
  colorForBottomBar: any;
  nowForPlay: any;
  bottomBarDataWithStyle: any;
  bottomBarTableStyles: any = {};
  gradientColors: any = [];
  gradientStyles: any = {};
  heightHundred: any = {};
  gradient: any;
  blockLayer: any;
  customMarker = new L.icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Map_marker_font_awesome.svg',
    iconSize: [35, 41],
    iconAnchor: [14, 41],
    popupAnchor: [15, -40]
  });
  yAxisMin: any;
  chartTableData: any;
  chartGradient: any;
  dateList: any;
  clickedLocationMarker: any;
  clickedLocationTooltip: any;
  bottomTableKeys: any = [];
  playWidth: any = 3;
  stateBoundary: any;
  basinBoundary: any;
  activeTimePeriod: any;
  districtClickedSubscription: any;
  adminBasinSubscription: any;
  forecastLengthSubscription: any;
  toggleSubscription: any;
  timeStampList: {};
  revalidateMapSubscription: any;
  selectedLocation: any;
  dataTabToggleVal = false;
  activeLayers: any = [];
  activeGroup: any;
  leftSideBarSubscription: any;
  apiData: any;
  type: string;
  apiParams: any;
  minMax: any;
  STATENAME: any;
  serviceMap: any;
  bottomBarComponent: any;
  legend: any;
  thresholdMap: object;
  initialCounter: number;
  style = {
    stroke: false,
    color: '#FF0000',
    fill: true,
    fillColor: '#FF0000',
    fillOpacity: 0.4,
    opacity: 0.4
  };
  componentType: string;
  hourCounter = '';
  blockNumber = 0;
  dateBlockNumMap = {};
  playPosition = 0;
  collapsebutton: any;
  activeSideMenu: any;
  polygons = [];
  bottombarClick: boolean;
  selectedComponent: string;
  meanMedian: string;
  showOption = false;
  selectedOption: any;

  view = 'Admin';

  subscriptions: Subscription[] = [];
  subscriptionCount = 0;
  regionSelected = 'southZone';
  baseLayers: any;
  layersList = {
    baseLayers: {}, overlayLayers: {}
  };
  metaData: any;
  basinTableDataForImpPoints: {};
  tableDataToDiplay: {};
  floodForecastWMSTileLayerConfig: any;
  stateUrlId: any;
  spinnerSubscription: any;
  regionSelectedSubscription: any;
  htmlLegendObjects: any = [];
  openDataTabSubscription: any;
  floodForecastFilterSubscription: Subscription;
  floodForecastPointGeoJson: any;
  navigationSubscription: Subscription;
  initSubScriptions: any = [true, true, true, true, true];
  throbbers: any = [false, false, false, false, false];
  htmlLegend: any;
  floodForecastGeoJSONLayersConfig: any;
  stateId = 'akbm';

  constructor(
    public mapService: MapService,
    public chartConstant: Chartconstant,
    private injector: Injector,
    public datepipe: DatePipe,
    private flowForecastUtils: FlowForecastUtilsService,
    private modalSrv: NgbModal,
    private utils: UtilsSharedModule
  ) {
    this.STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[this.stateId];
    let currentDate = new Date();
    currentDate = this.selectDateonBasisOfRFtime(currentDate);
    this.urlParams = {
      id: 'akbm',
      application: 'geo',
      locType: 'RESERVOIR',
      dashboardType: 'ff',
      component: 'floodforecast',
      srcType: 'southZone',
      locName: 'southZone',
      point: 'Sri Ram Sagar Project',
      pointType: 'project',
      heatmapType: 'Actual',
      source: 'NRSC',
      timeStep: 'Daily',
      sDate: moment(currentDate).format('YYYYMMDD'),
      eDate: moment(currentDate).format('YYYYMMDD'),
      aggType: 'SUM',
      locationType: 'command',
      heatmapReload: 'true',
      applyFilter: 'false',
      showSensorLayer: 'true',
    };
  }

  selectDateonBasisOfRFtime(date) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    let todayRFstartTs = currentDate.getTime();
    todayRFstartTs = todayRFstartTs + (8.5 * 3600000);
    const currentTs = new Date().getTime();
    if (currentTs < todayRFstartTs) {
      date.setDate(date.getDate() - 1);
    }
    return date;
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.initMap();
    // this.getBasinData();
    return;
  }

  initMap() {
    if (this.map) {
      this.map.remove();
    }
    this.map = new L.Map(this.mapId, this.otherOptions['metaData']['FloodForecastMapOptions'][this.regionSelected]);
    this.injectService();
    this.createPanes();
    this.addMapEvents();
  }

  injectService() {
    this.serviceMap = this.injector.get<any>(this.otherOptions['service']);
  }

  createPanes() {
    this.otherOptions['metaData']['FloodForecastMapPanes'].forEach(pane => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  public addMapEvents() {
    this.map.on({
      zoomend: () => {
        if (!this.floodForecastPointGeoJson) { return; }
        if (!this.metaData) { return; }
        if (!this.serviceMap) { return; }
        this.removeFlowLabels();
        this.serviceMap.addZoomLabels(this.floodForecastPointGeoJson, this.map, this.otherOptions['labelMetaData']);
      }
    });
  }

  removeFlowLabels() {
    if (this.serviceMap.labelLayerList) {
      for (const index in this.serviceMap.labelLayerList) {
        if (!isNullOrUndefined(index)) {
          const layer = this.serviceMap.labelLayerList[index];
          if (isNullOrUndefined(layer)) {
            continue;
          }
          if (this.map.hasLayer(layer)) {
            this.map.removeLayer(layer);
          }
        }
      }
    }
    this.serviceMap.labelLayerList = [];
  }

  getBasinData() {
    this.serviceMap.getMetaDataForAllPoints().subscribe(data => {
      this.metaData = data; // angular.fromJson(angular.toJson(data));
      this.setBaseLayersOnMap();
      this.setOverlayLayersOnMap();
    });
  }

  setBaseLayersOnMap() {
    // creating the tile layers to add onto the map object
    this.baseLayers = this.serviceMap.createBaseTileLayers(this.otherOptions['metaData']['FloodForecastBaseLayerOptions']);
    this.layersList.baseLayers = Object.assign(this.layersList.baseLayers, this.baseLayers);
    // adding the base layer to map object
    this.serviceMap.setBaseLayer(this.baseLayers, this);
  }

  setOverlayLayersOnMap() {
    if (!isNullOrUndefined(this.htmlLegend)) {
      this.map.removeControl(this.htmlLegend);
    }
    const htmlLegend = this.flowForecastUtils.createLegend();
    this.map.addControl(htmlLegend);
    this.htmlLegend = htmlLegend;

    this.floodForecastWMSTileLayerConfig = this.serviceMap.getApplicationBasedLayer('WMS', this.otherOptions['metaData']);
    this.floodForecastWMSTileLayerConfig = this.setLayersBasedOnView(this.floodForecastWMSTileLayerConfig, this.regionSelected);
    this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, this.serviceMap.setWmsTileLayers(this.floodForecastWMSTileLayerConfig, this));
    this.addForecastLegend(this.layers.overlaylayers, htmlLegend, true);

    let updatedView = this.regionSelected;
    if (this.regionSelected === 'godavariBasin') {
      this.addSubBasinLabel();
      updatedView = 'godavari';
    } else if (this.regionSelected === 'southZone') {
      updatedView = 'southzone';
    } else if (this.regionSelected === 'krishnaBasin') {
      updatedView = 'krishna';
    } else {
      updatedView = 'tsgodavari';
    }

    let basinView: string;
    if (this.regionSelected === 'godavariBasin') {
      // this.addSubBasinLabel();
      basinView = 'godavariNew';
    } else if (this.regionSelected === 'southZone') {
      basinView = 'southzone';
    } else if (this.regionSelected === 'krishnaBasin') {
      basinView = 'krishnaNew';
    } else {
      basinView = 'tsgodavari';
    }

    // NOTE :: RAINFALL AND FORECAST ACTUAL HEATMAPS FROM APWRIMS
    const shpBoundaryOptions = this.otherOptions['metaData']
    ['FloodForecastMapOptions'][this.regionSelected]['shpBoundaryOptions'];
    this.throbbers[4] = true;

    let geoJsonLayer = null;
    const filter = {
      filter: this.getfilter(this.regionSelected)
    };
    this.throbbers[0] = true;
    this.serviceMap.getGeoJSONData('VASSARLABS:flood_forecast_points_v8', filter).subscribe(jsonData => {
      this.serviceMap.drawFloodForecastPoints(jsonData, 'Inflow', this, this.metaData, this.modalSrv, this.urlParams, this.otherOptions['labelMetaData'], this.stateUrlId, this.regionSelected).then((data) => {
        geoJsonLayer = data;
        this.floodForecastPointGeoJson = jsonData;
        geoJsonLayer.options.group = 'Flood Forecast';
        geoJsonLayer.options.showOnSelector = true;
        geoJsonLayer.options.name = 'Flood forecast rivers';
        geoJsonLayer.options.visible = true;
        geoJsonLayer.options.legendData = this.otherOptions['metaData'].FloodForecastRiver['Flow Node'].legendData;
        const geoJsonLayerObject = { 'Flood forecast rivers': geoJsonLayer };
        this.addForecastLegend(geoJsonLayer, htmlLegend, false);
        geoJsonLayer.addTo(this.map);

        this.throbbers[0] = false;
        this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
      });
    });

    this.throbbers[1] = true;
    this.serviceMap.getGeoJSONData('VASSARLABS:flood_forecast_river_links_v8', filter).subscribe(jsonData => {
      this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId).then((data) => {
        const riverLayer: any = data;
        riverLayer.options.group = 'Flood Forecast';
        riverLayer.options.showOnSelector = true;
        riverLayer.options.name = 'Flood forecast rivers';
        riverLayer.options.visible = true;
        riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Rivers'].legendData;
        const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
        this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
        this.addForecastLegend(riverLayer, htmlLegend, false);
        riverLayer.addTo(this.map);

        this.throbbers[1] = false;
        /*
          NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
          would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
          then remove the spinner once river and point layer added on map.
        */
        if (this.urlParams.applyFilter !== 'true') {
          this.showThrobber = false;
        }
        this.showThrobber = false;
      });
    });
  }

  setLayersBasedOnView(layers, view) {
    const viewToLayerMap = {
      southZone: ['South Zone', 'South Zone Inverse', 'India Basin Inverse'],
      ap: ['AP', 'AP Inverse'],
      godavariBasin: ['Godavari', 'Godavari Inverse', 'Godavari Self Catchment'],
      krishnaBasin: ['Krishna', 'Krishna Inverse'],
      pennarBasin: ['Pennar', 'Pennar Inverse'],
      vamsadharaBasin: ['Vamsadhara', 'Vamsadhara Inverse'],
      nagavaliBasin: ['Nagavali', 'Nagavali Inverse'],
      godavariMask: ['Godavari Basin Mask Clip', 'Godavari Basin-Merge Mask Clip'],
      godavariTelangana: ['Godavari Telangana', 'Godavari Telangana Inverse']
    };
    for (const i in layers) {
      if (i) {
        if (viewToLayerMap[view].includes(i)) {
          layers[i].layerOptions.visible = true;
        } else {
          layers[i].layerOptions.visible = false;
        }
        if (this.regionSelected === 'godavariBasin') {

        }
      }
    }
    return layers;
  }

  addForecastLegend(layers, htmllegend, isLayersList) {
    if (isLayersList) {
      for (const key in layers) {
        if (key) {
          const newlayer = layers[key];
          if (newlayer.options.group == 'Rainfall Forecast' || newlayer.options.group == 'Rainfall Actual' ||
            newlayer.options.group === 'Raw Satellite' || newlayer.options.group === 'Inundation Area' ||
            newlayer.options.group == 'Rainfall Forecast') {
            const filterforecastLayer = layers[key];
            const legendData = filterforecastLayer.options.legendData;
            const legendInfoData = this.flowForecastUtils.getLegendData(legendData, filterforecastLayer);
            const legendObj = { name: newlayer.options.name, legend: legendInfoData, layer: newlayer };
            htmllegend.addLegend(legendInfoData);
            this.htmlLegendObjects.push(legendObj);
            // htmllegend.addLegend(legendInfoData);
          }
        }
      }
    } else {
      const legendInfoData = this.flowForecastUtils.getLegendData(layers.options.legendData, layers);
      const legendObj = { name: layers.options.name, legend: legendInfoData, layer: layers };
      htmllegend.addLegend(legendInfoData);
      // console.log(htmllegend)
      this.htmlLegendObjects.push(legendObj);
      // htmllegend.addLegend(legendInfoData);
    }
  }

  addSubBasinLabel() {
    const markerLayerGroup = new (L as any).layerGroup();
    for (const key in this.otherOptions['labelMetaData'].SubBasinPlot) {
      if (key) {
        const name = key;
        const gps = this.otherOptions['labelMetaData'].SubBasinPlot[key].gps;
        const htmlLabel = '<div style=\'font-size:' + this.map.getZoom() * 1.4 + 'px;color:black;width:80px\'>' + name + '</div>';
        const divObj = L.divIcon({ className: 'my-div-icon', html: htmlLabel });
        const marker = L.marker(gps, {
          pane: 'group2',
          icon: divObj,
          interactive: false
        });
        markerLayerGroup.addLayer(marker);
      }
    }
    this.map.addLayer(markerLayerGroup);
    this.activeLayers.push(markerLayerGroup);
    this.layersList.overlayLayers = Object.assign(this.layersList.overlayLayers, { 'Godavari Label Markers': markerLayerGroup });
  }

  getfilter(viewName: string) {
    let filter = '';
    // floodForecastMapDataService.getHighlightStations();
    if (viewName === 'ap') {
      filter = 'state = \'Andhra Pradesh\'';
    } else if (viewName === 'godavariBasin' || viewName === 'godavariTelangana') {
      filter = 'basin = \'GODAVARI-BASIN\'';
    } else if (viewName === 'krishnaBasin') {
      filter = 'basin = \'Krishna-Basin\'';
    } else if (viewName === 'pennarBasin') {
      filter = 'basin = \'PENNAR-BASIN\'';
    } else if (viewName === 'vamsadharaBasin') {
      filter = 'basin = \'VAMSADARA-BASIN\'';
    } else if (viewName === 'nagavaliBasin') {
      filter = 'basin = \'NAGAVALI-BASIN\'';
    }
    // else if (viewName === 'godavariTelangana')
    //   filter = "basin = 'Godavari Telangana Basin"
    return filter;
  }

  getTimestampFromDate() {
    let year;
    let month;
    let day;
    let startDate;
    let endDate;
    if (this.urlParams.timeStep === 'Daily') {
      startDate = this.urlParams.sDate;
      year = startDate.substring(0, 4);
      month = startDate.substring(4, 6);
      day = startDate.substring(6, 8);
      startDate = new Date(year, month - 1, day);

      endDate = this.urlParams.eDate;
      year = endDate.substring(0, 4);
      month = endDate.substring(4, 6);
      day = endDate.substring(6, 8);
      endDate = new Date(year, month - 1, day);
    } else if (this.urlParams.timeStep === 'Monthly') {
      startDate = this.urlParams.sDate;
      year = startDate.substring(0, 4);
      month = startDate.substring(4, 6);
      startDate = new Date(year, month - 1, 1);

      endDate = this.urlParams.eDate;
      year = endDate.substring(0, 4);
      month = endDate.substring(4, 6);
      let leapyear = false;
      if (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)) {
        leapyear = true;
      }
      const arr = [1, 3, 5, 7, 8, 10, 12];
      month = parseInt(month, 10);
      if (month === 2 && leapyear) {
        endDate = new Date(year, month - 1, 29);
      } else if (month === 2 && !leapyear) {
        endDate = new Date(year, month - 1, 28);
      } else if (arr.includes(month)) {
        endDate = new Date(year, month - 1, 31);
      } else {
        endDate = new Date(year, month - 1, 30);
      }
    } else if (this.urlParams.timeStep == 'Yearly') {
      startDate = this.urlParams.sDate;
      year = startDate.substring(0, 4);
      startDate = new Date(year, 5, 1);
      endDate = this.urlParams.eDate;
      year = endDate.substring(0, 4);

      year = parseInt(year, 10);
      endDate = new Date(year + 1, 4, 31);
    }
    if (!startDate || !endDate) {
      return null;
    }
    startDate.setHours(0, 0, 0, 0);
    let startTs = startDate.getTime();
    startTs = startTs + (8.5 * 3600000);

    endDate.setHours(0, 0, 0, 0);
    let endTs = endDate.getTime();
    endTs = endTs + (8.5 * 3600000);

    const timeArray = [];
    timeArray[0] = startTs;
    timeArray[1] = endTs;
    return timeArray;
  }

  removeOverlayLayerByName(layerName) {
    const layer = this.layersList['overlayLayers'][layerName];
    if (isUndefined(layer)) {
      return;
    }
    if (this.map.hasLayer(layer)) {
      this.map.removeLayer(layer);
    }
    delete this.layersList['overlayLayers'][layerName];
  }

  getRainfallLegend(startTs, endTs) {
    const diffDays = this.utils.getNoOfDaysBetweenTwoTimeStamps(startTs, endTs);
    if (diffDays >= 7) {
      return 'HIGH';
    }
    return 'LOW';
  }
}
